<template>
  <v-app style="background-color: rgb(var(--v-theme-background));">
    <v-app-bar :elevation="0" :image="require('./assets/bg.jpg')"
      v-if="isLoggedIn && !reqiureOtp && $vuetify.display.xs">
      <template v-slot:prepend>
        <v-app-bar-nav-icon color="white" @click="drawer = !drawer"></v-app-bar-nav-icon>
      </template>
      <template v-slot:image>
        <v-img gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"></v-img>
      </template>
      <Logo class="mx-2" :theme="`dark`" width="50px" />
      <h3 class="text-white">منصة نور التعليمية</h3>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" v-if="isLoggedIn && !reqiureOtp" :permanent="$vuetify.display.smAndUp"
      :rail="isDrawerCollapsed" :railWidth="103" app :width="320">
      <v-row @click="isDrawerCollapsed = !isDrawerCollapsed" :class="isDrawerCollapsed ? 'px-5' : 'px-10'"
        class="mt-5 flex-nowrap" align="center" justify="center">
        <v-col cols="auto" class="text-center align-center pa-0">
          <Logo :theme="isDarkMode ? 'dark' : 'light'" width="40px" />
        </v-col>
        <v-col id="logotext" style="text-wrap: nowrap;" class="animate__animated" v-if="!isDrawerCollapsed">
          <h3 class="font-weight-bold">منصة نور التعليمية</h3>
          <!-- <small style="font-weight: bold;">v{{ require('../package.json').version }}</small> -->
          <v-chip class="mt-2" variant="tonal" density="compact" color="primary"
            prepend-icon="mdi-account-circle-outline" v-if="userInfo">
            <b>{{ userInfo.first_name + ' ' + userInfo.last_name }}</b>
          </v-chip>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <v-list class="px-5" color="primary">
        <v-list-item density="compact" active-class="active"
          :class="`${!isDrawerCollapsed ? 'rounded-lg' : 'rounded-xl'} my-1 hover`" v-for="n in navigations"
          :key="n.title" :to="n.to">
          <v-list-item-title v-if="!isDrawerCollapsed">{{ n.title }}</v-list-item-title>
          <template v-slot:prepend>
            <VsxIcon :iconName="n.icon" :size="28" class="text-primary ml-5" type="bulk" />
          </template>
          <template v-if="n.count && !isDrawerCollapsed" v-slot:append>
            <v-chip :variant="isDarkMode ? 'flat' : 'tonal'" size="small" class="font-weight-bold" color="error">{{
              n.count }}</v-chip>
          </template>
        </v-list-item>
        <v-divider class="my-5"></v-divider>
        <v-list-item density="compact" active-class="active"
          :class="`${!isDrawerCollapsed ? 'rounded-lg' : 'rounded-xl'} my-1 hover`" v-for="n in supportNavigations"
          :key="n.title" :to="n.to">
          <v-list-item-title v-if="!isDrawerCollapsed">{{ n.title }}</v-list-item-title>
          <template v-slot:prepend>
            <VsxIcon :iconName="n.icon" :size="28" :class="`text-primary ml-5`" type="bulk" />
          </template>
          <template v-if="n.count && !isDrawerCollapsed" v-slot:append>
            <v-chip size="small" class="font-weight-bold" color="error">{{ n.count }}</v-chip>
          </template>
        </v-list-item>
        <v-divider class="my-5"></v-divider>
        <v-list-item density="compact" @click="isDarkMode = !isDarkMode; toggleDarkMode()"
          :class="`${!isDrawerCollapsed ? 'rounded-lg' : 'rounded-xl'} my-1 hover`">
          <v-list-item-title v-if="!isDrawerCollapsed">{{ !isDarkMode ? 'Dark mode' : 'Light mode'
          }}</v-list-item-title>
          <template v-slot:prepend>
            <VsxIcon :iconName="!isDarkMode ? 'Moon' : 'Sun1'" :size="28" :class="`text-primary ml-5`" type="bulk" />
          </template>
          <template v-if="!isDrawerCollapsed" v-slot:append>
            <v-switch v-model="isDarkMode" color="primary" density="compact" hide-details inset></v-switch>
          </template>
        </v-list-item>
        <v-list-item density="compact" @click="logoutDialog = true"
          :class="`${!isDrawerCollapsed ? 'rounded-lg' : 'rounded-xl'} my-1 hover`">
          <v-list-item-title v-if="!isDrawerCollapsed">تسجيل الخروج</v-list-item-title>
          <template v-slot:prepend>
            <VsxIcon iconName="Logout" :size="28" :class="`text-primary ml-5`" type="bulk" />
          </template>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-dialog persistent v-model="logoutDialog" width="auto">
      <v-card max-width="400" prepend-icon="mdi-information-outline" text="هل انت متأكد من تسجيل الخروج"
        title="تسجيل الخروج ؟">
        <template v-slot:actions>
          <v-btn :disabled="logoutLoading" :loading="logoutLoading" variant="tonal" color="error" text="نعم"
            @click="logout()"></v-btn>
          <v-btn :disabled="logoutLoading" variant="tonal" color="primary" text="لا"
            @click="logoutDialog = false"></v-btn>
        </template>
      </v-card>
    </v-dialog>


    <v-main>
      <template v-if="isLoggedIn">
        <div v-if="!reqiureOtp" :class="isMobile ? 'pa-5' : 'pa-10'">
          <router-view />
        </div>
        <div v-else>
          <OTP />
        </div>
      </template>
      <template v-else>
        <Login />
      </template>


    </v-main>
  </v-app>
</template>

<script setup>
import { useTheme } from 'vuetify'
const theme = useTheme()



const toggleDarkMode = () => {
  theme.global.name.value = theme.global.current.value.dark ? 'lightTheme' : 'darkTheme';
  localStorage.setItem('darkMode', theme.global.current.value.dark ? 1 : 0);
}

if (localStorage.getItem('darkMode') == 1) {
  toggleDarkMode();
}
</script>

<script>
import Logo from './components/Logo.vue';
import Login from "./views/Login.vue";
import OTP from './views/OTP.vue';
import * as moment from 'moment';
export default {
  name: 'App',
  components: {
    Logo,
    Login,
    OTP,
  },
  data: () => ({
    isDrawerCollapsed: false,
    drawer: false,
    isMobile: false,
    isLoggedIn: false,
    userInfo: null,
    user: null,
    logoutLoading: false,
    logoutDialog: false,
    reqiureOtp: false,
    navigations: [
      { title: 'الرئيسية', to: '/', icon: 'Home2' },
      { title: 'الاحصائيات', to: '/statistics', icon: 'StatusUp' },
      { title: 'المستخدمين', to: '/users', icon: 'Profile2User' },
      { title: 'طلبات البطاقات', to: '/requests', icon: 'CardReceive' },
      { title: 'تسجيل الطلاب', to: '/students-registration', icon: 'UserSquare' },
      { title: 'الكورسات', to: '/courses', icon: 'Book' },
      { title: 'مقارنة الكورسات', to: '/course-comparison', icon: 'ProgrammingArrows' },
      { title: 'الباقات', to: '/packages', icon: 'Card' },
      { title: 'الاشعارات', to: '/notifications', icon: 'MessageNotif' },
      { title: 'الاشعارات المجدولة', to: '/scheduled-notifications', icon: 'DirectNotification' },
      { title: 'OTP', to: '/otp', icon: 'SmsNotification' },
      { title: 'نقاط البيع', to: '/pos', icon: 'Shop' },
      { title: 'الصندوق المالي', to: '/accountants', icon: 'MoneyChange' },
      { title: 'مدير الملفات', to: '/file-manager', icon: 'Folder' },
      { title: 'الحملات', to: '/campaigns', icon: 'Driver2' },
      { title: 'WhatsApp', to: '/whatsapp', icon: 'Whatsapp' },
      { title: 'الاعدادات', to: '/settings/general', icon: 'Setting2' },
    ],
    supportNavigations: [
      { title: 'الدعم الفني', to: '/support', icon: 'MessageQuestion' },
    ],
    isDarkMode: false,
  }),
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    if (localStorage.getItem('darkMode') == 1) {
      this.isDarkMode = true;
    }
    if (localStorage.getItem("token")) {
      this.isLoggedIn = true;
      this.fetch();

    }
    if (this.$vuetify.display.smAndUp) {
      this.drawer = true;
    }
    if (this.$vuetify.display.xs) {
      this.isDrawerCollapsed = false;
    }
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    async fetch() {
      this.userInfo = (await this.$axios.get('users/me?fields=*,role.*')).data['data'];
      // check if userinro.last_otp is null or is expired: 10 min
      if (this.userInfo.last_otp == null || moment(this.userInfo.last_otp).add(7, 'days').isBefore(moment())) {
        this.reqiureOtp = true;
      } else {
        this.reqiureOtp = false;
      }
      this.$toast.success("اهلاً بك يا , " + this.userInfo.first_name + " " + this.userInfo.last_name, {
        position: "bottom-left",
      });
    },
    onResize() {
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        this.isDrawerCollapsed = true;
      } else {
        this.isDrawerCollapsed = false;
      }
    },
    toggleDrawer() {
      if (!this.isDrawerCollapsed) {
        document.getElementById("logotext").classList.add("animate__bounceOutUp");
        setTimeout(() => {
          this.isDrawerCollapsed = !this.isDrawerCollapsed;
          this.hideLogoText = !this.hideLogoText;
        }, 700);
      }
      if (this.isDrawerCollapsed) {
        this.isDrawerCollapsed = !this.isDrawerCollapsed;
        setTimeout(() => {
          this.hideLogoText = !this.hideLogoText;
        }, 200);

      }
    },
    async logout() {
      this.logoutLoading = true;
      await this.$axios.patch('users/me', {
        last_otp: null,
      });
      await this.$axios.post('auth/logout', {
        refresh_token: localStorage.getItem('refresh'),
      });
      localStorage.clear();
      window.location.href = '/'
    }
  }
}
</script>

<style src="./style.css"></style>
